import { useMutation } from "react-query"
import usePopup from "../../../hooks/usePopup"
import { saveLabResult } from "../services"

const useSaveLabResult = (successFunction?:()=>void)=>{
    const {showSnackbar} = usePopup()
    return useMutation(saveLabResult,{
        onSuccess:(result)=>{
            if(result.responseIndicator == "success"){
              showSnackbar({
                message:result.responseMessage,
                open:true,
                variant:"success",
                duration:3000
              })
              if(successFunction){
                successFunction()
              }
            }else{
              showSnackbar({
                message:result.responseMessage,
                open:true,
                variant:"warning",
                duration:3000
              })
            } 
        },
        onError:(e:any)=>{
          showSnackbar({
            message:e?.response?.data?.responseMessage || "Something went wrong !",
            open:true,
            variant:"error",
            duration:3000
          })
        }
      })
}

export default useSaveLabResult